// Removed getUnits import as we're moving away from unit-wise calculation
import { useCallback, useEffect, useState } from "react";

const useCustomerDetails = (
  me,
  // eslint-disable-next-line no-unused-vars
  setLoading = () => { },
  setVisibleCards = () => { }
) => {
  const [customerDetails, setCustomerDetails] = useState([]);

  // Use useCallback to prevent infinite loops
  const initializeData = useCallback(() => {
    if (!me || !me.customerId) return;
    setCustomerDetails([]);
  }, [me]);

  // Initialize data only once when the component mounts or when me changes
  useEffect(() => {
    initializeData();
    // Initialize visibleCards separately to avoid dependency cycle
    setVisibleCards([]);
  }, [initializeData, me?.customerId, setVisibleCards]);

  return [customerDetails];
};

export default useCustomerDetails;
